const AssociatedTask = ({task,completeTask,setCompleteTask,style={}}) => {
    return ( 
        <div style={style} className="alert alert-info flex-row p-3">
            <input
                checked={completeTask}
                onChange={(e)=>setCompleteTask(e.target.checked)}
                type="checkbox" 
                className={completeTask ? "form-check-input bg-info" :"form-check-input" }
            />
            <span className="ms-3">
                The submission will complete the task <b>"{task.title}"</b> Due on <b>"{task.deadlineInString}"</b>
            </span>
        </div>
    );
}
 
export default AssociatedTask;